import { CalcCaseProperty, CustomCaseProperty } from "generated/graphql";
import { useAppSelector } from "redux/hooks";
import { selectCalcProperties, selectCaseProperties } from "redux/slices/lensEditor";

export function useCaseProperty(key?: string | null): CustomCaseProperty | undefined {
  const caseProperties = useAppSelector(selectCaseProperties);

  if (key === undefined || key === null) return undefined;
  return caseProperties.find((cp) => cp.key === key);
}

export function useCaseCalc(key?: string | null): CalcCaseProperty | undefined {
  const calcs = useAppSelector(selectCalcProperties);

  if (key === undefined || key === null) return undefined;
  return calcs.find((c) => c.key === key);
}
